(async () => {
  if (!customElements.get('product-bundles')) {
    const { Fancybox } = await import('@fancyapps/ui');

    class ProductBundles extends HTMLElement {
      constructor() {
        super();

        // main inits
        this.set = [];
        this.fancybox = null;
        this.discount = this.querySelector('[data-product-bundles-discount]').dataset.productBundlesDiscount;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.mainID = new Date().getTime();

        // Bind modals
        this.querySelectorAll('[data-product-modal]').forEach((modal) => {
          modal.addEventListener('click', this.openModal.bind(this));
        });

        this.querySelectorAll('[data-product-bundle-close]').forEach((close) => {
          close.addEventListener('click', this.removeItem.bind(this));
        });

        this.querySelector('[data-product-bundle-atc]').addEventListener('click', this.addSet.bind(this));
        this.grid = this.querySelector('[data-product-bundles-grid]');
        this.grid.addEventListener('scroll', debounce(() => this.scrollTrigger(), 10).bind(this));
      }

      /**
       * openModal
       * @description Opens product modal
       */
      openModal(event) {
        let target = event.target;
        let productHandle = '';
        let that = this;

        if (target.dataset) {
          if (target.dataset.productModal) {
            productHandle = target.dataset.productModal
          } else {
            productHandle = target.closest('[data-product-modal]').dataset.productModal
          }
        } else {
          productHandle = target.closest('[data-product-modal]').dataset.productModal
        }

        if (productHandle != '') {
          let fetchUrl = location.origin + '/products/' + productHandle + '?view=bundle-modal'
    
          fetch(fetchUrl)
          .then((response) => {
            return response.text()
          })
          .then(html => {
            new Fancybox(
              [
                {
                  src: html,
                  type: "html",
                },
              ],
              {
                on: {
                  done: (fancybox, slide) => {
                    that.handleModal(fancybox, slide);
                  }
                }
              }
            );
          })
        }
      }

      /**
       * handleModal
       * @description Handles modal options
       */
      handleModal(fancybox, html) {
        let el = html.$el;
        this.fancybox = fancybox;

        // handle color switch
        el.querySelectorAll('[data-product-bundle-color]').forEach((color) => {
          color.addEventListener('click', this.switchColor.bind(this));
        });

        // handle add to set
        el.querySelector('[data-product-bundle-variant-id]').addEventListener('click', this.addToSet.bind(this));
        
      }

      /**
       * switchColor
       * @description Switch color in modal
       */
      switchColor(event) {
        let target = event.target;
        if (!target.dataset.productBundleColor) {
          target = target.closest('[data-product-bundle-color]')
        }
        let colorName = target.dataset.productBundleColor;
        let colorNameDisplay = target.dataset.productBundleColorDisplay;
        let colorHex = target.dataset.productBundleColorHex;
        let id = target.dataset.productBundleColorId;

        // switch gallery
        let gallery = document.querySelector('[data-product-bundle-gallery="' + colorNameDisplay + '"]');
        if (gallery !== null) {
          document.querySelectorAll('[data-product-bundle-gallery]').forEach((gallery) => {
            gallery.querySelector('img').classList.add('hidden');
          })
          gallery.querySelector('img').classList.remove('hidden');
        } else {
          gallery = document.querySelector('.product-bundles__modal-gallery');
        }

        let image = gallery.querySelector('img').src;

        // switch content
        let currentColor = target.closest('[data-product-bundle-wrapper]').querySelector('[data-selected-variant]');
        currentColor.querySelector('[data-product-bundle-color-name]').innerText = colorNameDisplay;
        currentColor.querySelector('[data-product-bundle-color-hex]').style.background = colorHex;

        // switch class
        target.closest('[data-product-bundle-wrapper]').querySelector('[data-product-bundle-color].active').classList.remove('active');
        target.classList.add('active');

        // update add to set
        target.closest('[data-product-bundle-wrapper]').querySelector('[data-product-bundle-variant-id]').dataset.productBundleVariantHex = colorHex;
        target.closest('[data-product-bundle-wrapper]').querySelector('[data-product-bundle-variant-id]').dataset.productBundleVariantColor = colorName;
        target.closest('[data-product-bundle-wrapper]').querySelector('[data-product-bundle-variant-id]').dataset.productBundleVariantId = id;
        //target.closest('[data-product-bundle-wrapper]').querySelector('[data-product-bundle-variant-id]').dataset.productBundleVariantImage = image;
      }

      /**
       * addToSet
       * @description Add variant to set
       */
      addToSet(event) {
        let target = event.target;
        let id = target.dataset.productBundleVariantId;
        let img = target.dataset.productBundleVariantImage;
        let color = target.dataset.productBundleVariantColor;
        let hex = target.dataset.productBundleVariantHex;
        let entry = id + '|' + img + '|' + color + '|' + hex;

        if (this.set.length == 3) {
          let someArr = [];
          let finalIndex = this.set.length - 1;
          this.set.forEach((set, index) => {
            if (index < finalIndex) {
              someArr.push(set);
            }
          });
          this.set = someArr;
        }
        this.set.push(entry);
        this.fancybox.close();
        this.handleSet();
      }

      /**
       * handleSet
       * @description Handles set
       */
      handleSet() {

        let barsArr = document.querySelectorAll('[data-product-bundle-bars] [data-index]');
        document.querySelector('.bundle-count').innerText = this.set.length;
        document.querySelector('[data-product-bundle-count]').innerText = 3 - this.set.length;
        let bundlePlaceholderArr = document.querySelectorAll('[data-product-bundle-placeholder]');

        if (this.set.length < 1) {
          barsArr.forEach((bar) => {
            bar.classList.remove('bg-primary');
          });
        } else {
          this.set.forEach((set, index) => {
            barsArr[index].classList.add('bg-primary');
            let setArr = set.split('|');
            let id = setArr[0];
            let img = setArr[1];
            let color = setArr[2];
            let hex = setArr[3];
            bundlePlaceholderArr[index].querySelector('img').src = img;
            let spanArr = bundlePlaceholderArr[index].querySelector('p').querySelectorAll('span');
            bundlePlaceholderArr[index].classList.remove('ready');
            bundlePlaceholderArr[index].classList.add('active');
            spanArr[0].style.background = hex;
            if (hex.length > 0) {
              spanArr[0].classList.remove('hidden');
            } else {
              spanArr[0].classList.add('hidden');
            }
            spanArr[1].innerText = color;
          });
        }

        for (let i = 0; i < 3; i++) {

          if (i >= this.set.length) {
            bundlePlaceholderArr[i].classList.remove('active')
            bundlePlaceholderArr[i].classList.remove('ready')
            if (i == this.set.length) {
              bundlePlaceholderArr[i].classList.add('ready')
            }
          }

        }

        if (this.set.length == 3) {
          document.querySelector('[data-product-bundle-incomplete]').classList.add('hidden');
          document.querySelector('[data-product-bundle-complete]').classList.remove('hidden');
          document.querySelector('[data-product-bundle-atc]').disabled = false;
        } else {
          document.querySelector('[data-product-bundle-atc]').disabled = true;
          document.querySelector('[data-product-bundle-complete]').classList.add('hidden');
          document.querySelector('[data-product-bundle-incomplete]').classList.remove('hidden');
        }

      }

      /**
       * removeItem
       * @description Removes item from set
       */
      removeItem(event) {
        let target = event.target;
        if (!target.dataset.productBundleClose) {
          target = event.target.closest('[data-product-bundle-close]')
        }
        let itemIndex = target.dataset.productBundleClose;

        let someArr = [];
        this.set.forEach((set, index) => {
          if (itemIndex != index) {
            someArr.push(set);
          }
        });
        this.set = someArr;
        this.handleSet();
      }

      /**
       * addSet
       * @description Add set to cart
       */
      addSet() {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
    
        const sectionsToFetch  = [
          ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ];
    
        let items = [];
        let object = {};

        this.set.forEach((set) => {
          let setArr = set.split('|')
          object = {};
          object = {
            quantity: 1,
            id: parseFloat(setArr[0]),
            properties: {
              "product_bundle": 'Bundle-' + this.mainID,
              "_product_bundle_name": 'Build Your Own Bundle',
              "_product_bundle_discount": this.discount,
              "_funnel": 'PDP',
              "_funnel_location": 'MAIN ATC',
              "_funnel_type": 'manual'
            }
          }
          items.push(object);
        });
    
        let body = JSON.stringify({
          items: items,
          sections: sectionsToFetch,
          sections_url: window.location.pathname
        });
    
        fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
          .then((response) => response.json())
          .then((parsedState) => {
      
            localStorage.removeItem('refused_gifts');

            if (this.cartDrawer) {
              this.renderContents(parsedState);
            }

            document.body.classList.remove('product-bundle-is-open');
            
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.cartDrawer.open();
            this.set = [];
            this.handleSet();
          });

      }

      renderContents(parsedState) {

        this.getSectionsToRender().forEach((section) => {
          if (section?.selector) {
            const selector = document.querySelector(section.selector);
            if (selector) {
              selector.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector
              );
            }
          }
        });

        this.cartDrawer.querySelectorAll('[data-cart-button-close]').forEach((btn) =>
          btn.addEventListener('click', this.close.bind(this))
        );
    
      }

      getSectionsToRender() {
        return [
          {
            id: 'cart-drawer',
            selector: '[data-cart-drawer]',
          },
          {
            id: 'cart-icon-bubble',
            selector: '[data-cart-icon-bubble]',
          },
        ];
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }

      close() {
        document.body.classList.remove('cart-drawer-is-open');
        document.body.removeEventListener('click', this.onBodyClick);
      }

      /**
       * On window scroll event trigger
       * @returns void
       */
      scrollTrigger() {
        const scrollTop = this.grid.scrollY || this.grid.scrollTop;

        if (scrollTop > 80) {
          document.querySelector('[data-scroller]').classList.add('scrolled');
        }
        if (scrollTop == 0) {
          document.querySelector('[data-scroller]').classList.remove('scrolled');
        }
      }

    }

    window.ProductBundles = ProductBundles;
    customElements.define('product-bundles', ProductBundles);
  }
})();
